export const ADMIN_UID =
  process.env.NEXT_PUBLIC_SUPPORT_ID ?? 'O4lXAvXpd1ahfKeYFPGE51JMeGI3';

type PermissionLevel = 1 | 2 | 3; // lower level is more permissions
export const SUPPORT_UIDS: Record<
  string,
  { level: PermissionLevel; label: string; email: string }
> = {
  [ADMIN_UID]: { level: 1, label: 'Admin', email: 'support@mxlocker.com' },
  ZBJq1AFxendUtAMv9gEqvNuakar1: {
    level: 2,
    label: 'Julius',
    email: 'mxsupport@mxlocker.com',
  },
  ZCij00MZ5vOzuCDYhs2JW87oZQE2: {
    level: 3,
    label: 'Chesilyn',
    email: 'mxsupport+1@mxlocker.com',
  },
  eOOJPbSwiDXwDpOUg09ojkZ2IGD3: {
    level: 2,
    label: 'Kurt Lucas',
    email: 'mxsupport+2@mxlocker.com',
  },
  AJPQHlWHk0b8Y3m53W85Opq7gZp2: {
    level: 3,
    label: 'David',
    email: 'mxsupport+3@mxlocker.com',
  },
};

export function hasSupportPermission(
  uid?: string | null,
  level?: PermissionLevel
): boolean {
  if (!uid || !SUPPORT_UIDS[uid]) return false;
  return level ? level >= SUPPORT_UIDS[uid].level : true;
}

// For boot trade-ins
// info@mxlocker.com, username: MXLocker
export const MX_LOCKER_ACCOUNT_UID = 'FjBH0nwiHgGV4Y0EXDQS';

export function canUseRequestPayment(uid?: string | null): boolean {
  return hasSupportPermission(uid, 2) || uid === MX_LOCKER_ACCOUNT_UID;
}

export function canTransferBuyer(uid?: string | null): boolean {
  return hasSupportPermission(uid) || uid === MX_LOCKER_ACCOUNT_UID;
}
